import React, { useEffect } from 'react';

import { withFormField } from '@gogame/form';
import { Select } from '@gogame/components';

import { OS } from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { loadOS } from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';
import {
  CREATIVE_TYPE_BANNER,
  CREATIVE_TYPE_CINEMAGRAPH,
  CREATIVE_TYPE_GIF,
  CREATIVE_TYPE_VIDEO,
} from 'scenes/Gallery/GalleryPage/constants';

export const isActiveOS = (creativeType) =>
  [
    CREATIVE_TYPE_BANNER,
    CREATIVE_TYPE_GIF,
    CREATIVE_TYPE_VIDEO,
    CREATIVE_TYPE_CINEMAGRAPH,
  ].includes(creativeType);

const OSComponent = withFormField({
  name: OS,
  source: loadOS,
})(({ creativeType, value, area, onChange }) => {
  const active = isActiveOS(creativeType);

  useEffect(() => {
    if (creativeType && !active && value) {
      onChange(null, undefined);
    }
  }, [creativeType]);

  return (
    <Select
      label={'OS'}
      value={value}
      loading={area.loading}
      options={area.data}
      onChange={onChange}
      disabled={!active}
      canDeselect={true}
      dropdownWidth={200}
    />
  );
});

export default OSComponent;
